import { Observable } from 'rxjs';
import { Injectable, InjectionToken, Inject, Optional } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { PlatformService } from '../services/platform/platform.service';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
export const defaultTimeout = 20000;

@Injectable()
export class VCInterceptor implements HttpInterceptor {
  constructor(
    @Inject(DEFAULT_TIMEOUT) protected timeOutDefault,
    @Optional() @Inject(REQUEST) protected serverReq,
    private platform: PlatformService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutRequest = Number(req.headers.get('timeout')) || this.timeOutDefault;

    if (this.platform.isServer && this.serverReq) {
      req = req.clone({
        setHeaders: {
          'X-Forwarded-For': this.serverReq.ip
        }
      });
    }

    return next.handle(req).pipe(timeout(timeoutRequest));
  }
}
